import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAsyncActions } from 'react-async-client';
import Translate from 'react-translate-component';

import { getNews } from 'actions/asyncActions';
import { fullAutoOptions } from 'constants/asyncClient';
import SidebarContainer from '../../SidebarContainer';
import DocumentList from 'components/common/fields/DocumentList';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

@withAsyncActions({ getNews: getNews.withDefaultPayload(({ id }) => id )}, fullAutoOptions)
export default class NewsSidebarView extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
        getNews: PropTypes.object.isRequired,
        params: PropTypes.object.isRequired
    }

    render() {
        const { title } = this.props.params;
        const { meta, refresh, data: { documents, newsData = {} } } = this.props.getNews;

        return (
            <SidebarContainer title={title} meta={meta} refresh={refresh} footer={null}>
                { meta.success && (
                    <div>
                        <div className="panel-view" dangerouslySetInnerHTML={{__html: newsData.body}} />
                        <DefinitionHeader iconType='text-document'>
                            <Translate content="common.attachments" />
                        </DefinitionHeader>
                        <DocumentList documents={documents} />
                    </div>
                ) }
            </SidebarContainer>
        )
    }
}
